export interface CategoryEntry {
  key: string;
  label: string;
  desc: string;
  icon: string;
  type?: string;
  region?: string;
}

export const categoryEntries: CategoryEntry[] = [
  { key: 'movie', label: '电影', desc: '银幕光影中的汉字瞬间', icon: 'ri-film-line', type: '电影' },
  { key: 'tv', label: '电视剧', desc: '长篇叙事里的文字线索', icon: 'ri-tv-2-line', type: '电视剧' },
  { key: 'history', label: '历史古装', desc: '考据严谨的朝代故事', icon: 'ri-ancient-gate-line', region: '中国大陆' },
  { key: 'suspense', label: '悬疑推理', desc: '以汉字为钥的解谜之作', icon: 'ri-search-eye-line', region: '中国香港' },
  { key: 'culture', label: '文化专题', desc: '书写工具与礼制文明', icon: 'ri-book-2-line', region: '中国台湾' },
  { key: 'warm', label: '温情成长', desc: '平凡故事里的文字温度', icon: 'ri-heart-line', region: '中国大陆' },
];

export const typeOptions = ['全部', '电影', '电视剧'];
export const regionOptions = ['全部', '中国大陆', '中国香港', '中国台湾', '日本', '韩国'];
export const ratingOptions = ['全部', '9分以上', '8分以上', '7分以上'];
export const sortOptions = [
  { key: 'update', label: '按更新时间' },
  { key: 'heat', label: '按热度' },
  { key: 'title', label: '按字母序' },
];